import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import { Map, List } from 'immutable';

import RaceCard from '@xanadu/ui-shared/components/GlobalEventsPage/RacingSportPage/components/RaceCard';
import { track } from '@xanadu/ui-shared/interfaces/woopra';

import { PRODUCTS } from '../../../constants';


// TODO: make this async with react router 4
import Streaming from '../../../containers/Streaming';
import RelatedEvents from '../../../containers/SingleEventPage/RelatedEvents';
import NextUpEvent from '../../../containers/NextUpEvent';

import { getCategoryUrlFromTags } from '../utils';

import styles from './Aside.module.scss';

export default function Aside({
  enablePIP,
  streamDetails,
  streamInfo,
  eventId,
  pipEnabled,
  eventSport,
  eventCountry,
  eventOtherTags,
  product,
  urlPrefix,
  tags,
}) {
  const isMBZero = product === PRODUCTS.mbzero;
  const category = useMemo(() => (
    getCategoryUrlFromTags(tags, [...eventOtherTags, eventCountry])
  ), [tags, eventOtherTags, eventCountry]);

  const onEnablePIP = useCallback(() => {
    enablePIP({ enabled: true, eventId });
    track('streaming', 'Enable PiP', {
      description: eventId
    });
  });

  const onDisablePIP = useCallback(() => {
    enablePIP({ enabled: false, eventId });
  });

  let nextStream;
  if (streamDetails && streamDetails.size > 0) {
    streamDetails.forEach(stream => {
      if (stream.isNextStream) {
        nextStream = stream;
      }
    });
  }

  const isGreyhoundRace = eventSport.urlName === 'greyhound-racing';
  const isHorseRace = eventSport.urlName === 'horse-racing';
  const isRacing = isHorseRace || isGreyhoundRace;
  const isUSARace = ['usa'].includes(eventCountry.urlName);

  const isEventAvailableForStreaming = streamInfo.find(stream => stream.eventId === eventId)
    && !isMBZero;

  return (
    <aside className={`${styles.aside} ${!eventId && (styles['aside--hide'])}`}>
      {!isRacing && <RelatedEvents eventId={eventId || null} />}
      {isRacing && (
        <NextUpEvent sportUrlName={eventSport.urlName} />
      )}
      {pipEnabled || isEventAvailableForStreaming ?
        <Streaming
          onEnablePIP={onEnablePIP}
          onDisablePIP={onDisablePIP}
          pip={pipEnabled}
          mobileStream={false}
          isEventAvailableForStreaming={isEventAvailableForStreaming}
          isHorseRace={isHorseRace}
          isUSARace={isUSARace}
          sportUrlName={eventSport.urlName}
        /> : null
      }
      {eventSport && isHorseRace && (
        <RaceCard
          category={category}
          urlPrefix={urlPrefix}
          mode="compact"
        />
      )}
      {pipEnabled && nextStream ?
        <Streaming
          nextStream={nextStream}
          isEventAvailableForStreaming={isEventAvailableForStreaming}
          isHorseRace={isHorseRace}
          isUSARace={isUSARace}
          sportUrlName={eventSport.urlName}
          onEnablePIP={onEnablePIP}
          onDisablePIP={onDisablePIP}
          pip={false}
          mobileStream={false}
        /> : null
      }
    </aside>
  );
}

Aside.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  enablePIP: PropTypes.func.isRequired,
  streamDetails: PropTypes.instanceOf(Map),
  streamInfo: PropTypes.instanceOf(Map),
  eventId: PropTypes.string,
  product: PropTypes.string.isRequired,
  pipEnabled: PropTypes.bool.isRequired,
  eventSport: PropTypes.object,
  eventOtherTags: PropTypes.instanceOf(List),
  eventCountry: PropTypes.object,
  urlPrefix: PropTypes.string,
  tags: PropTypes.instanceOf(List),
};
